import { AttrMap, IndexedMesh }  from "./indexed-mesh";
import { IndexedMeshWriter } from "./indexed-mesh-writer";


export class ReverseWinding<T extends AttrMap> extends IndexedMeshWriter<T> {

    /** The mesh to  */
    writer: IndexedMeshWriter<T>;

    /**
     * Note that this does not copy the input mesh data; it acts in place. You
     * could pass a `Clone` mesh writer if you want to use the underlying
     * writer instance in another pipeline.
     */
    constructor(writer: IndexedMeshWriter<T>) {
        super();
        this.writer = writer;
    }

    computeAttributeCounts(): IndexedMesh<T> {
        return this.writer.computeAttributeCounts();
    }

    computeMeshData(result: IndexedMesh<T>): void {
        this.writer.computeMeshData(result);

        const idx = result.index.data;

        // For every triangle, if we swap the first and third vertexes, (called
        // a and c respectively), we will effectively reverse the winding
        // order. We use a temporary variable to do the swap.
        for(let a = 0; a < idx.length; a += 3) {
            const
                temp = idx[a],
                c = a + 2;
            idx[a] = idx[c];
            idx[c] = temp;
        }
    }
}
